import React, { useState, useEffect, useRef } from "react";
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Label,
  Row,
} from "reactstrap";
import BreadCrumb from "../../components/common/breadCrumb";
import { getRole } from "../../utils/helpers/custom";
import * as Yup from "yup";
import { Formik, FieldArray } from "formik";
import {
  InputPlaceHolder,
  SelectPlaceHolder,
  validationMessages,
} from "../../utils/helpers/validationMasseges";
import ApproveRejectModal from "../../components/common/approveRejectModal";
import PreviewCardHeader from "../../components/common/previewCardHeader";
import { Link, useNavigate, useParams } from "react-router-dom";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import {
  addProject,
  deleteProjectDetails,
  listOfProject,
  updateProject,
} from "../../api/itpProject";
import { developmentData } from "../../utils/helpers/enums";
import { toast } from "react-toastify";
import { ItpLabel } from "../../common/constant/Itp";
import {
  checkStatusCodeSuccess,
  CommonLabel,
  Roles,
} from "../../utils/helpers/common";
import BaseButton from "../../components/BaseComponents/BaseButton";
import BaseInput from "../../components/BaseComponents/BaseInput";
import { BaseSelect } from "../../components/BaseComponents/BaseSelect";
import Loader from "../../components/common/loader";

const ITPProjectDetails = (props) => {
  document.title = ItpLabel.ItpProjectDetail;
  const role = getRole();
  const maxCharacterLimit = 5000;
  const navigate = useNavigate();
  const { itpProjectId } = useParams();
  const [loading, setLoading] = useState(false);
  const [pageLoader, setPageLoader] = useState(false);
  const [selectedDevelopMent, setSelectedDevelopMent] = useState();
  const [deleteModal, setDeleteModal] = useState(false);
  const [arrayHelpersState, setArrayHelpersState] = useState();
  const [indexState, setIndexState] = useState();
  const [selectedProject, setSelectedProject] = useState([]);
  const [deleteTopicId, setDeleteTopicId] = useState(undefined);
  const [errorIndices, setErrorIndices] = useState([]);
  const [openFlush, setOpenFlush] = useState([]);
  const fieldRefs = useRef([]);

  useEffect(() => {
    arrayHelpersState?.remove(indexState);
  }, [arrayHelpersState, indexState]);

  const itpDelete = (id, arrayHelpers, index) => {
    setDeleteTopicId(id);
    setArrayHelpersState(arrayHelpers);
    setIndexState(index);
  };

  useEffect(() => {
    if (itpProjectId !== undefined) {
      setPageLoader(true);
      listOfProject({
        itpProjectId,
      })
        .then((res) => {
          if (checkStatusCodeSuccess(res?.statusCode)) {
            setSelectedProject(res?.data);
          } else {
            toast.error(res?.data?.message);
          }
        })
        .catch((err) => err)
        .finally(() => {
          setPageLoader(false);
        });
    }
  }, [itpProjectId]);

  useEffect(() => {
    if (deleteTopicId !== undefined) {
      setLoading(true);
      deleteProjectDetails({ id: deleteTopicId })
        .then((res) => {
          if (checkStatusCodeSuccess(res?.data?.statusCode)) {
            arrayHelpersState?.remove(indexState);
            setDeleteTopicId(undefined);
          } else {
            toast.error(res?.data?.message);
          }
        })
        .catch((err) => err)
        .finally(() => {
          setLoading(false);
        });
    }
  }, [deleteTopicId]);

  const initialValues = {
    projectName: selectedProject[0]?.projectName || "",
    development: selectedProject[0]?.development || "",
    remark: selectedProject[0]?.remark || "",
    projectDetails:
      selectedProject[0]?.itpProjectDetails?.map((detail) => ({
        id: +detail.id || "",
        module: detail.module || "",
        days: detail.days || "",
        apis: detail.apis || "",
        screen: detail.screen || "",
        apiEndPoints: detail.apiEndPoints || "",
      })) || [],
  };

  const validationSchema = Yup.object({
    projectName: Yup.string().required(
      validationMessages.required(ItpLabel.ProjectName)
    ),
    remark: Yup.string().required(
      validationMessages.required(ItpLabel.Remark)
    ),
    development: Yup.string().required(
      validationMessages.required(ItpLabel.Development)
    ),
    projectDetails: Yup.array().of(
      Yup.object().shape({
        module: Yup.string().required(
          validationMessages.required(ItpLabel.Module)
        ),
        days: Yup.string().required(validationMessages.required(ItpLabel.Day)),
        apis: Yup.string().optional(),
        apiEndPoints: Yup.string()
          .required(validationMessages.required(ItpLabel.ApiEndPoints))
          .test(
            "max-length",
            validationMessages.maxLength(
              ItpLabel.ApiEndPoints,
              maxCharacterLimit
            ),
            (value) => {
              const textContent = value?.replace(/<[^>]*>/g, "");
              return textContent?.length <= maxCharacterLimit;
            }
          ),
        screen: Yup.string().optional(),
      })
    ),
  });
  
  const handleError = (values, { errors }) => {
    const errorKeys = Object.keys(errors).filter(
      (key) => !Array.isArray(errors[key])
    );
    
    if (errorKeys.length > 0) {
      if (errorKeys[0] === "remark") {
        setTimeout(() => {
          const errorMessage = document.querySelector(`#error-remark`);

          if (errorMessage) {
            errorMessage.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
            errorMessage.focus();
          }
        }, 100);
      } else {
        const firstErrorField = document.querySelector(
          `[name="${errorKeys[0]}"]`
        );
        const visibleParent =
          firstErrorField.closest(".custom-select-container") ||
          firstErrorField.closest(".select-border") ||
          firstErrorField;
        setTimeout(() => {
          visibleParent.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
          visibleParent.focus();
        }, 100);
      }
      return;
    }
    
    const errorIndicesArray = [];
    if (errors?.projectDetails) {
      errors?.projectDetails?.forEach((error, index) => {
        if (error) {
          errorIndicesArray.push(index);
        }
      });
    }
    setErrorIndices(errorIndicesArray);

    const openAccordionIds = errorIndicesArray.map(
      (index) => `project-detail-${index}`
    );
    setOpenFlush((prevOpenFlush) => {
      return [...new Set([...prevOpenFlush, ...openAccordionIds])];
    });

    if (errorIndicesArray.length > 0) {
      const firstErrorIndex = errorIndicesArray[0];
      const firstErrorModuleErrors = errors.projectDetails[firstErrorIndex];
      if (firstErrorModuleErrors) {
        const firstErrorFieldName = Object.keys(firstErrorModuleErrors).find(
          (key) => firstErrorModuleErrors[key]
        );
        if (firstErrorFieldName) {
          if (firstErrorFieldName === "apiEndPoints") {
            setTimeout(() => {
              const errorMessage = document.querySelector(
                `#error-projectDetails-${firstErrorIndex}-apiEndPoints`
              );

              if (errorMessage) {
                errorMessage.scrollIntoView({
                  behavior: "smooth",
                  block: "center",
                });
                errorMessage.focus();
              }
            }, 100);
          } else {
            const selector = `#projectDetails\\.${firstErrorIndex}\\.${firstErrorFieldName}`;
            const firstErrorField = document.querySelector(selector);

            if (firstErrorField) {
              firstErrorField.scrollIntoView({
                behavior: "smooth",
                block: "center",
              });
            }
          }
        }
      }
    }
  };
  const handleSubmit = (values) => {
    if (values.projectDetails?.length > 0) {
      setLoading(true);
      if (itpProjectId === undefined) {
        addProject({ ...values })
          .then((res) => {
            if (checkStatusCodeSuccess(res?.data?.statusCode)) {
              navigate("/itp-project");
              toast.success(res?.data?.message);
            } else {
              toast.error(res?.data?.message);
            }
          })
          .catch((err) => err)
          .finally(() => {
            setLoading(false);
          });
      } else {
        const projectDetails = values?.projectDetails.map((res) => {
          return {
            id: res.id,
            module: res.module,
            apiEndPoints: res.apiEndPoints,
            apis: res.apis,
            screen: res.screen,
            days: res.days,
          };
        });
        updateProject({ ...values, itpProjectId: +itpProjectId, projectDetails })
          .then((res) => {
            if (checkStatusCodeSuccess(res?.data?.statusCode)) {
              navigate("/itp-project");
              toast.success(res?.data?.message);
            } else {
              toast.error(res?.data?.message);
            }
          })
          .catch((err) => err)
          .finally(() => {
            setLoading(false);
          });
      }
    } else {
      toast.error(ItpLabel.ModuleErrorMessage);
    }
  };

  const customToolbarConfig = {
    toolbar: {
      items: [
        "heading",
        "|",
        "bold",
        "italic",
        "underline",
        "link",
        "|",
        "bulletedList",
        "numberedList",
        "|",
        "insertTable",
        "|",
        "undo",
        "redo",
      ],
    },
  };

  const toggleFlush = (id) => {
    if (openFlush.includes(id)) {
      setOpenFlush(openFlush.filter((item) => item !== id));
    } else {
      setOpenFlush([...openFlush, id]);
    }
  };

  return (
    <React.Fragment>
      <ApproveRejectModal
        show={deleteModal}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title={ItpLabel.CreateProject}
            pageTitle={ItpLabel.ItpProject}
            navigation="/itp-project"
          />
          <Row className="mb-2">
            <div className="col-sm order-3 order-sm-2 mt-3 mt-sm-0">
              <h5 className="fw-semibold mt-2">
                {ItpLabel.ItpFullForm} {ItpLabel.Project}
              </h5>
            </div>
            <div className="col-auto order-2 order-sm-3 ms-auto">
              <div className="hstack gap-2">
                {role !== Roles.Employee && (
                  <Link to="/itp-project">
                    <BaseButton color="primary" type="button">
                      {CommonLabel.Back}
                    </BaseButton>
                  </Link>
                )}
              </div>
            </div>
          </Row>
        </Container>
        {pageLoader === false ? (
          <Card>
            <PreviewCardHeader title={ItpLabel.Project} />
            <CardBody>
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                enableReinitialize
              >
                {({
                  values,
                  handleSubmit: formikHandleSubmit,
                  handleChange,
                  handleBlur,
                  errors,
                  touched,
                  setFieldValue,
                  setTouched,
                }) => (
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      if (Object.keys(errors).length === 0) {
                        handleSubmit(values, { errors });
                      } else {
                        handleError(values, { errors });
                      }
                    }}
                  >
                    <Row className="g-4 mb-3">
                      <Col
                        lg={itpProjectId ? 12 : 6}
                        md={itpProjectId ? 12 : 6}
                        sm={12}
                      >
                        <div className="mb-1">
                          <BaseInput
                            type="text"
                            name="projectName"
                            label={ItpLabel.ProjectName}
                            placeholder={InputPlaceHolder(ItpLabel.ProjectName)}
                            value={values.projectName}
                            onChange={handleChange}
                            handleBlur={handleBlur}
                            error={errors.projectName}
                            touched={touched.projectName}
                            required
                          />
                        </div>
                      </Col>
                      {itpProjectId === undefined && (
                        <Col lg={6} md={6} sm={12}>
                          <BaseSelect
                            name="development"
                            label={ItpLabel.Development}
                            options={developmentData}
                            placeholder={SelectPlaceHolder(
                              ItpLabel.Development
                            )}
                            value={values.development}
                            handleChange={(field, value) => {
                              setFieldValue(field, value);
                              setSelectedDevelopMent(value);
                            }}
                            handleBlur={handleBlur}
                            error={errors.development}
                            touched={touched.development}
                            required
                          />
                        </Col>
                      )}

                      <Col lg={12}>
                        <div>
                          <Label htmlFor="remark" className="form-label required">
                            <strong>{ItpLabel.Remark}</strong>
                          </Label>

                          <CKEditor
                            editor={ClassicEditor}
                            data={values.remark}
                            config={customToolbarConfig}
                            onChange={(event, editor) => {
                              const data = editor?.getData();
                              const textContent = data?.replace(/<[^>]*>/g, "");
                              if (textContent?.length <= maxCharacterLimit) {
                                handleChange("remark")(data);
                              }
                            }}
                          />
                          <p id="error-remark" className="validateError"> { errors.remark } </p>
                          <p>
                            {ItpLabel.CharCount}:
                            {values.remark?.replace(/<[^>]*>/g, "")?.length} /
                            {maxCharacterLimit}
                          </p>
                          {values.remark?.replace(/<[^>]*>/g, "")?.length >=
                            maxCharacterLimit && (
                            <p className="validateError">
                              {ItpLabel.CharLimitExceed}
                            </p>
                          )}
                        </div>
                      </Col>
                    </Row>
                    <Card>
                      <PreviewCardHeader title="Project Details" />
                      <CardBody>
                        <FieldArray
                          name="projectDetails"
                          render={(arrayHelpers) => (
                            <div className="live-preview">
                              <Accordion
                                id="project-details-accordion"
                                flush
                                open={openFlush}
                                toggle={toggleFlush}
                              >
                                {values.projectDetails.map((user, index) => (
                                  <AccordionItem key={index}>
                                    <AccordionHeader
                                      className="custom-accordion-header"
                                      targetId={`project-detail-${index}`}
                                    >
                                      <Row
                                        xs="2"
                                        style={{ display: "contents" }}
                                      >
                                        <Col className="d-flex align-items-center custom_css_font_color">
                                          {ItpLabel.Module} {index + 1}
                                        </Col>
                                        <Col>
                                          <BaseButton
                                            type="button"
                                            color="danger"
                                            onClick={() =>
                                              itpDelete(
                                                user.id,
                                                arrayHelpers,
                                                index
                                              )
                                            }
                                          >
                                            <i className="ri-delete-bin-2-fill"></i>{" "}
                                          </BaseButton>
                                        </Col>
                                      </Row>
                                    </AccordionHeader>
                                    <AccordionBody
                                      accordionId={`project-detail-${index}`}
                                    >
                                      <Row className="mb-1">
                                        <Col
                                          lg={
                                            selectedDevelopMent === ItpLabel.FE
                                              ? 3
                                              : 4
                                          }
                                          sm={6}
                                        >
                                          <FormGroup>
                                            <BaseInput
                                              type="text"
                                              name={`projectDetails.${index}.module`}
                                              id={`projectDetails.${index}.module`}
                                              label={ItpLabel.Module}
                                              placeholder={InputPlaceHolder(
                                                ItpLabel.Module
                                              )}
                                              value={
                                                values.projectDetails[index]
                                                  .module
                                              }
                                              onChange={handleChange}
                                              handleBlur={handleBlur}
                                              error={
                                                errors.projectDetails?.[index]
                                                  ?.module
                                              }
                                              touched={
                                                touched.projectDetails?.[index]
                                                  ?.module
                                              }
                                              required
                                            />
                                          </FormGroup>
                                        </Col>

                                        <Col
                                          lg={
                                            selectedDevelopMent === ItpLabel.FE
                                              ? 3
                                              : 4
                                          }
                                          sm={6}
                                        >
                                          <FormGroup>
                                            <BaseInput
                                              type="number"
                                              name={`projectDetails.${index}.days`}
                                              id={`projectDetails.${index}.days`}
                                              label={ItpLabel.Day}
                                              placeholder={InputPlaceHolder(
                                                ItpLabel.Day
                                              )}
                                              value={
                                                values.projectDetails[index]
                                                  .days
                                              }
                                              onChange={handleChange}
                                              handleBlur={handleBlur}
                                              error={
                                                errors.projectDetails?.[index]
                                                  ?.days
                                              }
                                              touched={
                                                touched.projectDetails?.[index]
                                                  ?.days
                                              }
                                              required
                                            />
                                          </FormGroup>
                                        </Col>
                                        {selectedDevelopMent ===
                                          ItpLabel.FE && (
                                          <Col md={3} lg={3} sm={6}>
                                            <FormGroup>
                                              <BaseInput
                                                type="number"
                                                name={`projectDetails.${index}.screen`}
                                                id={`projectDetails.${index}.screen`}
                                                label={ItpLabel.Screen}
                                                placeholder={InputPlaceHolder(
                                                  ItpLabel.Screen
                                                )}
                                                value={
                                                  values.projectDetails[index]
                                                    .screen
                                                }
                                                onChange={handleChange}
                                                handleBlur={handleBlur}
                                                error={
                                                  errors.projectDetails?.[index]
                                                    ?.screen
                                                }
                                                touched={
                                                  touched.projectDetails?.[
                                                    index
                                                  ]?.screen
                                                }
                                                required
                                              />
                                            </FormGroup>
                                          </Col>
                                        )}
                                        <Col
                                          lg={
                                            selectedDevelopMent === ItpLabel.FE
                                              ? 3
                                              : 4
                                          }
                                          sm={6}
                                        >
                                          <FormGroup>
                                            <BaseInput
                                              type="number"
                                              name={`projectDetails.${index}.apis`}
                                              id={`projectDetails.${index}.apis`}
                                              label={ItpLabel.Api}
                                              placeholder={InputPlaceHolder(
                                                ItpLabel.Api
                                              )}
                                              value={
                                                values.projectDetails[index]
                                                  .apis
                                              }
                                              onChange={handleChange}
                                              handleBlur={handleBlur}
                                              error={
                                                errors.projectDetails?.[index]
                                                  ?.apis
                                              }
                                              touched={
                                                touched.projectDetails?.[index]
                                                  ?.apis
                                              }
                                              a
                                            />
                                          </FormGroup>
                                        </Col>
                                      </Row>
                                      <Row className="mb-3">
                                        <Col lg={12}>
                                          <div className="inputPadding">
                                            <Label
                                              for={`projectDetails.${index}.remark`}
                                              className="form-label custom_css_font_color"
                                            >
                                              <strong className="required">
                                                {ItpLabel.ApiEndPoints}
                                              </strong>
                                            </Label>
                                            <CKEditor
                                              name={`projectDetails.${index}.apiEndPoints`}
                                              id={`projectDetails.${index}.apiEndPoints`}
                                              editor={ClassicEditor}
                                              data={user.apiEndPoints}
                                              config={customToolbarConfig}
                                              onChange={(event, editor) => {
                                                const data = editor?.getData();
                                                setFieldValue(
                                                  `projectDetails.${index}.apiEndPoints`,
                                                  data
                                                );
                                              }}
                                            />
                                            {errors.projectDetails?.[index]
                                              ?.apiEndPoints &&
                                              touched.projectDetails?.[index]
                                                ?.apiEndPoints && (
                                                <p
                                                  id={`error-projectDetails-${index}-apiEndPoints`}
                                                  className="validateError"
                                                >
                                                  {
                                                    errors.projectDetails[index]
                                                      .apiEndPoints
                                                  }
                                                </p>
                                              )}
                                          </div>
                                        </Col>
                                      </Row>
                                    </AccordionBody>
                                  </AccordionItem>
                                ))}
                              </Accordion>
                              <BaseButton
                                type="button"
                                color="success"
                                onClick={() =>
                                  arrayHelpers.push({
                                    topicName: "",
                                    link: "",
                                    hour: "",
                                  })
                                }
                              >
                                <i className="ri-add-line mt-2" />
                                {ItpLabel.Module}
                              </BaseButton>
                            </div>
                          )}
                        />
                      </CardBody>
                    </Card>
                    <div className="hstack gap-2 justify-content-end">
                      <Link to="/itp-project">
                        <BaseButton type="button" color="ghost-success">
                          <i className="ri-close-fill align-bottom"></i>{" "}
                          {CommonLabel.Close}
                        </BaseButton>
                      </Link>
                      <BaseButton
                        type="submit"
                        color="primary"
                        loader={loading}
                        onClick={() => {
                          setTouched({
                            projectName: true,
                            development: true,
                            remark: true,
                            projectDetails: values.projectDetails?.map(() => ({
                              module: true,
                              days: true,
                              screen: true,
                              apis: true,
                              apiEndPoints: true,
                            })),
                          });
                        }}
                      >
                        {itpProjectId === undefined
                          ? CommonLabel.Submit
                          : CommonLabel.Update}
                      </BaseButton>
                    </div>
                  </Form>
                )}
              </Formik>
            </CardBody>
          </Card>
        ) : (
          <Loader />
        )}
      </div>
    </React.Fragment>
  );
};

export default ITPProjectDetails;
